module.exports = __webpack_public_path__ + "img/MHB-logo-černé.29e7574d.png";